<div class="app-version" [class.desktop]="!mobile" [class.mobile]="mobile">
    {{ appConfig.getVersion() }}
</div>
